module.exports = __webpack_public_path__ + "img/newsImg2-1.f66c286e.png";